import { IconComponentProps } from '../IconTypes';

const SidePanel = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M10.1818 6.13636H20.1818C20.5584 6.13636 20.8636 6.44162 20.8636 6.81818V17.7273C20.8636 18.1038 20.5584 18.4091 20.1818 18.4091H10.1818V6.13636ZM9.04545 6.13636H3.81818C3.44162 6.13636 3.13636 6.44162 3.13636 6.81818V17.7273C3.13636 18.1038 3.44162 18.4091 3.81818 18.4091H9.04545V6.13636ZM10.1818 5H20.1818C21.186 5 22 5.81403 22 6.81818V17.7273C22 18.7314 21.186 19.5455 20.1818 19.5455H10.1818H3.81818C2.81403 19.5455 2 18.7314 2 17.7273V6.81818C2 5.81403 2.81403 5 3.81818 5H10.1818Z"
      fill="#646D82"
      fillRule="evenodd"
    />
  </svg>
);

export default SidePanel;
